import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo } from 'react';
import useQueryParams from 'data-hooks/useQueryParams';
import { DEFAULT_SORT_ORDER } from 'commons/constants';
const SORT_BY_QUERY_KEY = 'sortBy';
const getSortByValueFromQueryParams = queryParams => queryParams[SORT_BY_QUERY_KEY] ?? DEFAULT_SORT_ORDER;
const useProductListingUrlSortByState = () => {
  const $ = _c(7);
  const [queryParams, setQueryParams] = useQueryParams();
  let t0;
  if ($[0] !== queryParams) {
    t0 = getSortByValueFromQueryParams(queryParams);
    $[0] = queryParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const sortOrder = t0;
  let t1;
  if ($[2] !== setQueryParams) {
    t1 = updatedSortOrder => {
      const updatedQueryParams = updatedSortOrder === DEFAULT_SORT_ORDER ? {
        [SORT_BY_QUERY_KEY]: null
      } : {
        [SORT_BY_QUERY_KEY]: updatedSortOrder
      };
      setQueryParams(updatedQueryParams);
    };
    $[2] = setQueryParams;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const setSortOrder = t1;
  let t2;
  if ($[4] !== setSortOrder || $[5] !== sortOrder) {
    t2 = [sortOrder, setSortOrder];
    $[4] = setSortOrder;
    $[5] = sortOrder;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
export default useProductListingUrlSortByState;